import React, { useEffect, useMemo } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import ProtectedRoute from "./protectedRoute";
import CompanyProtectedRoute from "./companyProtectedRoute";
import Dashboard from "../pages/Dashboard";
import Vehicles from "../pages/Vehicles";
import FleetReports from "../pages/Report";
import FleetReportDetails from "../pages/ReportDetails";
import Orders from "../pages/Orders";
import BuyGps from "../pages/BuyGps";
import BuyGpsFuel from "../pages/BuyGpsFuel";
import Faqs from "../pages/Faqs";
import Setting from "../pages/Setting";
import Support from "../pages/Support";
import Profile from "../pages/Profile";
import ProfileEdit from "../pages/ProfileEdit";
import TripCalculator from "../pages/TripCalculator";
import Documents from "../pages/Documents";
import Login from "../pages/login";
import RequestOtp from "../pages/RequestOtp";
import VehicleInfo from "../pages/VehicleInfo";
import VehiclePlayRoute from "../pages/VehicleRoute";
import Geofence from "../pages/Geofence";
import GeofenceDashboard from "../pages/GeofenceDashboard";
import FuelTheft from "../pages/FuelTheft";
import Alerts from "../pages/Alerts";
import User from "../pages/User";
import GeofenceEdit from "../pages/GeofenceEdit";
import SharePage from "../pages/Share";
import CompanyLogin from "../pages/Company/CompanyLogin";
import AddLoadForm from "../pages/Company/AddLoad";
import UpdateLoadForm from "../pages/Company/updateLoad";
import LoadList from "../pages/Company/ListLoad";
import Load from "../pages/Company/Load/load";
// TMS Pages
import RoutesPage from "../pages/TMS/Routes";
import RouteAddPage from "../pages/TMS/Routes/Add";
import RouteEditPage from "../pages/TMS/Routes/Edit";
// import TripList from "../pages/Company/TripList";
import TokenPayment from "../pages/TokenPayment";
// import Tripdetails from "../pages/Company/TripDetails";
// import TripMapContainer from "../components/TripMapContainer";
// sedhal added
import CompanyDashboard from "../pages/Company/Dashboard/dashboard";
import Trips from "../pages/Company/Trips";
import ProfileCompany from "../pages/Company/Company_Profile/profile";
import Tripdetails from "../pages/Company/TripDetails/tripDetail";
import Notification from "../pages/Company/Notification/notification";
import SupportLoad from "../pages/Company/Support/support";
import Firm from "../pages/TMS/Firms";
import AddFirm from "../pages/TMS/Firms/Add";
import Vendor from "../pages/TMS/Vendors/vendor";
import AddVendor from "../pages/TMS/Vendors/ADD/addVendor";
import Commodity from "../pages/TMS/Commodities/commodities";
import AddCommodity from "../pages/TMS/Commodities/ADD/addComodity";
import UpdateFirm from "../pages/TMS/Firms/Update/updateFirm";
import UpdateVendor from "../pages/TMS/Vendors/Update/updateVendor";
import UpdateCommodity from "../pages/TMS/Commodities/Update/updateCommodity";
import AddClient from "../pages/TMS/Clients/ADD/addClient";
import UpdateClient from "../pages/TMS/Clients/Update/updateclient";
// import AddressBook from "../pages/TMS/AddressBook/addressbook";
// import AddAddressbook from "../pages/TMS/AddressBook/Add/addAdressbook";
import AddTags from "../pages/TMS/Setting/ADDTAGS/addTags";
import AddTrip from "../pages/TMS/Trip/AddTrip";
import Client from "../pages/TMS/Clients/client";
import AddDriver from "../pages/TMS/tmsDriver.js/ADD/addDriver";
import Driver from "../pages/TMS/tmsDriver.js/driver";
import UpdateDriver from "../pages/TMS/tmsDriver.js/Update/updateDriver";
import SpeechBubble from "../pages/TMS/Trip/TripDetails/tripDetails";
import UpdateTrip from "../pages/TMS/Trip/Update/updateTrip";
import TripDashboard from "../pages/TMS/Trip/TripDashboard/dashboard";
import TyreManagement from "../pages/TyreManagement";
import TruckTireSelector from "../pages/TyreManagement/tyreAdd";
import TyreChange from "../pages/TyreManagement/TyreChange";
import AssignSingleTyre from "../pages/TyreManagement/AssignSingleTyre";
import VehicleBaseTyreList from "../pages/TyreManagement/vehicleBaseTyrelist";
const BaseRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  var currentLocation = window.location.pathname;
  const ftmUserData = localStorage.getItem("ftmUserData");
  const ltmsCompanyData = localStorage.getItem("ltmsCompanyData");
  
  useEffect(() => {
    // Redirect to appropriate login page if user is not authenticated
    const isSharePage = location.pathname.includes("/share");
    if (!ftmUserData && !ltmsCompanyData && !isSharePage) {
      if (location.pathname.includes("company/login")) {
        navigate("company/login");
      } else {
        navigate("/login");
      }
    } else if (
      ltmsCompanyData &&
      (currentLocation === "/" || currentLocation === "company/login")
    ) {
      navigate("/company/loads");
    } else if (
      (ftmUserData && currentLocation === "/") ||
      currentLocation === "/login"
    ) {
      navigate("/dashboard");
    }
  }, []);

  const userData = useMemo(() => {
    return ftmUserData ? JSON.parse(ftmUserData) : null;
  }, [ftmUserData]);

  const userType = useMemo(() => {
    if (ftmUserData) return "fleetOwner";
    if (ltmsCompanyData) return "company";
    return null;
  }, [ftmUserData, ltmsCompanyData]);
  const isAllowedUser = userData?.id === "655b0fa8d4616f050d60027b";
  return (
    <>
      <div className="app-container">
        <Routes>
          {/* Protected Routes Start */}
          {userType === "fleetOwner" && (
            <Route exact path="/" element={<ProtectedRoute />}>
              <Route exact path="/dashboard" element={<Dashboard />} />
              <Route path="/token-payment" element={<TokenPayment />} />
              <Route path="/users" element={<User />} />
              <Route path="/vehicles" element={<Vehicles />} />
              <Route path="/vehicles/:id" element={<VehicleInfo />} />
              <Route path="/playback/:id" element={<VehiclePlayRoute />} />
              <Route path="/geofence" element={<GeofenceDashboard />} />
              <Route exact path="/geofence/create" element={<Geofence />} />
              <Route exact path="/geofence/edit" element={<GeofenceEdit />} />
              <Route
                path="/fuel-theft"
                element={
                  userData?.isFuel ? (
                    <FuelTheft />
                  ) : (
                    <Navigate to="/dashboard" replace />
                  )
                }
              />
              <Route path="/fleet-reports" element={<FleetReports />} />
              <Route
                path="/fleet-reports/:slug"
                element={<FleetReportDetails />}
              />
              <Route path="/orders" element={<Orders />} />
              <Route path="/plans/buy-gps" element={<BuyGps />} />
              <Route path="/plans/buy-gps-fuel" element={<BuyGpsFuel />} />
              <Route path="/faqs" element={<Faqs />} />
              <Route path="/settings" element={<Setting />} />
              <Route path="/trip-calculator" element={<TripCalculator />} />
              <Route path="/support" element={<Support />} />
              <Route path="/profile/:id" element={<Profile />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/profile/edit/:id" element={<ProfileEdit />} />
              <Route path="/alerts" element={<Alerts />} />
              {/* TMS Routes */}
              {isAllowedUser && (
                <>
                  <Route path="/tms/routes" element={<RoutesPage />} />
                  <Route path="/tms/routes/add" element={<RouteAddPage />} />
                  <Route
                    path="/tms/routes/edit/:id"
                    element={<RouteEditPage />}
                  />
                  <Route path="/tms/firms" element={<Firm />} />
                  <Route path="/tms/add/firms" element={<AddFirm />} />
                  <Route path="/tms/update/firms" element={<UpdateFirm />} />
                  <Route path="/tms/vendors" element={<Vendor />} />
                  <Route path="/tms/add/vendors" element={<AddVendor />} />
                  <Route
                    path="/tms/update/vendors"
                    element={<UpdateVendor />}
                  />
                  <Route path="/tms/commodities" element={<Commodity />} />
                  <Route
                    path="/tms/add/commodities"
                    element={<AddCommodity />}
                  />
                  <Route
                    path="/tms/update/commodities"
                    element={<UpdateCommodity />}
                  />
                  <Route path="/tms/add/clients" element={<AddClient />} />
                  <Route path="/tms/clients" element={<Client />} />
                  <Route
                    path="/tms/update/clients"
                    element={<UpdateClient />}
                  />
                  <Route path="/tms/add/trip" element={<AddTrip />} />
                  <Route path="/tms/update/trip" element={<UpdateTrip />} />
                  <Route path="/tms/setting/AddTags" element={<AddTags />} />
                  <Route path="/tms/add/driver" element={<AddDriver />} />
                  <Route path="/tms/update/driver" element={<UpdateDriver />} />
                  <Route path="/tms/driver" element={<Driver />} />
                  <Route path="/tms/trip-details" element={<SpeechBubble />} />
                  <Route
                    path="/tms/trip-dashboard"
                    element={<TripDashboard />}
                  />
                </>
              )}
              {/* <Route path="/tms/address_book" element={<AddressBook />} />
                <Route
                  path="/tms/add/address_book"
                  element={<AddAddressbook />}
                /> */}
              <Route
                path="/tyre-management"
                element={
                  isAllowedUser ? (
                    <TyreManagement />
                  ) : (
                    <Navigate to="/dashboard" replace />
                  )
                }
              />
              <Route path="/add-tyre" element={<TruckTireSelector />} />
              <Route path="/tyre-assign" element={<TyreChange />} />
              <Route
                path="/single_tyre_assign"
                element={<AssignSingleTyre />}
              />
              <Route
                path="/vehicle_tyre_list"
                element={<VehicleBaseTyreList />}
              />
            </Route>
          )}
          {userType === "company" && (
            <Route exact path="/" element={<CompanyProtectedRoute />}>
              <Route path="/company/dashboard" element={<CompanyDashboard />} />
              <Route path="/company/loads" element={<LoadList />} />
              <Route path="/company/add_load" element={<AddLoadForm />} />
              <Route path="/company/upadte_load" element={<UpdateLoadForm />} />
              <Route path="/company/Load/" element={<Load />} />
              <Route path="/company/trips" element={<Trips />} />
              <Route path="/company/trip/:id" element={<Tripdetails />} />
              <Route path="/company/profile/:id" element={<ProfileCompany />} />
              <Route path="/company/notifications" element={<Notification />} />
              <Route path="/company/support" element={<SupportLoad />} />
            </Route>
          )}
          {/* Protected Routes End */}
          {/* Unprotected Routes Start */}
          <Route path="/share/:id" element={<SharePage />} />
          <Route exact path="/company/login" element={<CompanyLogin />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/request-otp" element={<RequestOtp />} />
          {/* Unprotected Routes End */}
        </Routes>
      </div>
    </>
  );
};

export default BaseRoutes;